import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Form, Segment, Label, Dropdown, Input } from 'semantic-ui-react';
import CleanableDatepicker from 'common/components/CleanableDatepicker';
import Timepicker from 'common/components/Timepicker';
import { getWorkers } from '../reducers/requirements';
import { getVisit } from '../reducers/form';
import PreplannificationInput from 'saas/aast/common/components/PreplannificationInput';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';
import moment from 'moment';
import { updateData } from '../actions/form';
import WorkerDropdown from '../../common/components/WorkerDropdown';
import { getTimeUnits } from '../../cases-creation/step2/reducers/requirements';

export class Plannification extends React.Component {
  constructor(props) {
    super(props);

    this._renderPrimaryWorkersOptions = this._renderPrimaryWorkersOptions.bind(
      this
    );
    this._renderSecondaryWorkersOptions = this._renderSecondaryWorkersOptions.bind(
      this
    );
  }

  _renderPrimaryWorkersOptions() {
    return this.props.workers.map(w => ({
      key: w.id,
      text: w.display_name,
      value: w.id,
    }));
  }

  _renderSecondaryWorkersOptions() {
    return this.props.workers
      .filter(
        w => this.props.workerId === undefined || this.props.workers !== w.id
      )
      .map(w => ({
        key: w.id,
        text: w.display_name,
        value: w.id,
      }));
  }

  render() {
    const {
      planningDate,
      planningTime,
      preplanningDate,
      workerId,
      secondaryWorkers,
      readOnly,
      timeUnits,
    } = this.props;

    return (
      <Segment>
        <Form.Group>
          <Form.Field width={9}>
            <label>Date ou semaine</label>
            <Form.Group>
              <Form.Field width={6}>
                <CleanableDatepicker
                  identifier="date"
                  name="planningDate"
                  value={planningDate || ''}
                  onChange={this.props.updatePlanningDate}
                  placeholder="JJ/MM/AAAA"
                  disabled={readOnly}
                />
              </Form.Field>
              <Form.Field width={3}>
                <Timepicker
                  name="planningTime"
                  value={planningTime || ''}
                  onChange={this.props.updatePlanningTime}
                  disabled={readOnly}
                />
              </Form.Field>
              <Form.Field width={1} style={{ paddingTop: '7px' }}>
                <Label circular color="grey">
                  ou
                </Label>
              </Form.Field>
              <Form.Field width={6}>
                <PreplannificationInput
                  name="preplanningDate"
                  value={preplanningDate || ''}
                  onChange={this.props.updatePreplanningDate}
                  placeholder="Semaine"
                  disabled={readOnly}
                />
              </Form.Field>
            </Form.Group>
          </Form.Field>
          <Form.Field width={7}>
            <label>Durée de l'intervention</label>
            <Input
              value={this.props.visitDuration}
              type="number"
              label={
                <Dropdown
                  value={this.props.visitDurationUnit}
                  options={timeUnits.map(tu => ({
                    key: tu.id,
                    text: tu.label,
                    value: tu.id,
                  }))}
                  basic
                  onChange={(_, value) =>
                    this.props.updateVisitDurationUnit(value.value)
                  }
                />
              }
              labelPosition="right"
              placeholder="Durée"
              disabled={readOnly}
              onChange={(_, value) =>
                this.props.updateVisitDuration(parseInt(value.value, 0))
              }
            />
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <WorkerDropdown
            workers={this.props.workers}
            canDelete={!readOnly}
            workerId={workerId}
            onChange={id => {
              if (id) this.props.updateWorkerId(parseInt(id, 0));
              else {
                this.props.updateWorkerId(id);
              }
            }}
            disabled={readOnly}
          />
          <Form.Field width={11}>
            <label>Techniciens secondaires</label>
            <Dropdown
              selection
              multiple
              options={this._renderSecondaryWorkersOptions()}
              value={secondaryWorkers || []}
              onChange={(_, value) =>
                this.props.updateSecondaryWorkerIds(value.value)
              }
              disabled={readOnly}
            />
          </Form.Field>
        </Form.Group>
      </Segment>
    );
  }
}

Plannification.propTypes = {
  workers: PropTypes.array.isRequired,
  workerId: PropTypes.number,
  secondaryWorkers: PropTypes.array,
  planningDate: PropTypes.string,
  planningTime: PropTypes.string,
  preplanningDate: PropTypes.string,
  readOnly: PropTypes.bool,
  visitDuration: PropTypes.string,
  visitDurationUnit: PropTypes.number,
};

const mapStateToProps = (state, ownProps) => ({
  timeUnits: getTimeUnits(state),
  workers: getWorkers(state),
  workerId: getVisit(state).workerId,
  secondaryWorkers: getVisit(state).secondaryWorkers,
  planningDate: getVisit(state).planningDate,
  planningTime: getVisit(state).planningTime,
  preplanningDate: getVisit(state).preplanningDate,
  visitDuration: getVisit(state).duration,
  visitDurationUnit: getVisit(state).durationTimeUnit,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  updatePlanningDate: date => {
    if (date) {
      dispatch(
        updateData('visit.planningDate', moment(date.date).format(DATE_FORMAT))
      );
    } else {
      dispatch(updateData('visit.planningDate', date));
    }
  },
  updatePlanningTime: time => dispatch(updateData('visit.planningTime', time)),
  updatePreplanningDate: date =>
    dispatch(updateData('visit.preplanningDate', date)),
  updateWorkerId: id => dispatch(updateData('visit.workerId', id)),
  updateSecondaryWorkerIds: ids =>
    dispatch(updateData('visit.secondaryWorkers', ids)),
  updateVisitDurationUnit: id =>
    dispatch(updateData('visit.durationTimeUnit', id)),
  updateVisitDuration: value => dispatch(updateData('visit.duration', value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Plannification);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/Plannification.js